module.exports = __webpack_public_path__ + "img/Frente-47-00 off.38a15b3c.png";